import { h, Fragment } from 'preact';
import { useMemo, useState, useRef, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import Calendar from 'react-calendar';
import { format } from 'date-fns';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'utils/image';
import ArrowLeft from '../utils/icon/arrow-left.svg';
import AddToCartButton from './product-add-to-cart';
import { isValidEmail } from '../utils/helpers';
import { useWindowSize } from '../utils/window-size';

const Rise = ({ currentVariant, currentProduct }) => {
  const formRef = useRef(null);
  const closeRise = new CustomEvent('rise:close');
  const [errors, setErrors] = useState({ name: false, email: false });
  const [giftLoading, setGiftLoading] = useState(false);
  const [giftImages, setGiftImages] = useState(false);
  const [selectedImage, setSelectedImage] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const technicalDataEl = document.querySelector('[data-technical]');
  const technicalData = JSON.parse(technicalDataEl.textContent);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    try {
      fetch(
        // eslint-disable-next-line max-len
        `https://application.rise-ai.com/integrations/inbound/gifting/assets?shop_url=${technicalData.shopName}`,
        {
          headers: {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'x-rise-gifting-api-key': technicalData.xRiseGiftingApiKey,
          },
          method: 'GET',
        },
      )
        .then((response) => response.json())
        .then((result) => {
          setGiftImages(result?.assets?.gallery_images_urls);
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, []);

  useEffect(() => {
    setSelectedImage(giftImages[0]);
  }, [giftImages]);


  useEffect(() => {
    const handleRiseGift = (event) => {
      const { form } = event.detail;
      if (giftLoading) return false;
      setGiftLoading(true);
      let formValid = true;
      const errorsList = {};
      const formData = [];
      form.current.forEach((input) => {
        formData.push(input);
        if (input.required && !input.value) {
          formValid = false;
          errorsList[input.name] = true;
        }
        if (input.name === 'email' && !isValidEmail(input.value)) {
          formValid = false;
          errorsList[input.name] = true;
        }
      });
      setErrors(errorsList);

      if (formValid) {
        const giftPayload = {
          gift: {
            value: parseInt(currentVariant.price.amount, 10),
            name: formData.find((input) => input.name === 'name').value,
            email: formData.find(
              (input) => input.name === 'email' && input.value,
            )
              ? formData.find((input) => input.name === 'email' && input.value)
                  ?.value
              : null,
            image: selectedImage,
            message: formData.find(
              (input) => input.name === 'greeting' && input.value,
            )
              ? formData.find(
                  (input) => input.name === 'greeting' && input.value,
                )?.value
              : window.TMW.Strings.risegift.defaultGiftMessage,
            send_at: formData.find(
              (input) => input.name === 'send-time' && input.value !== 'false',
            )
              ? formData.find(
                  (input) =>
                    input.name === 'send-time' && input.value !== 'false',
                )?.value
              : null,
            sending_method: formData.find(
              (input) => input.name === 'sending-method',
            ).value,
            variant_id: formData.find((input) => input.name === 'variant-id')
              .value,
          },
        };
        try {
          fetch(
            // eslint-disable-next-line max-len
            `https://application.rise-ai.com/integrations/inbound/gifting/session?shop_url=${technicalData.shopName}`,
            {
              headers: {
                accept: 'application/json, text/plain, */*',
                'content-type':
                  'application/x-www-form-urlencoded;charset=UTF-8',
                'x-rise-gifting-api-key': technicalData.xRiseGiftingApiKey,
              },
              method: 'POST',
            },
          )
            .then((response) => response.json())
            .then((result) => {
              const sessionId = result.session.id;
              const myHeaders = new Headers();
              myHeaders.append(
                'X-Shopify-Storefront-Access-Token',
                technicalData.xShopifyStorefrontAccessToken,
              );
              myHeaders.append(
                'x-rise-gifting-api-key',
                technicalData.xRiseGiftingApiKey,
              );
              myHeaders.append('Content-Type', 'application/json');
              const raw = JSON.stringify(giftPayload);
              const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow',
              };
              fetch(
                // eslint-disable-next-line max-len
                `https://application.rise-ai.com/integrations/inbound/gifting/session/${sessionId}/?shop_url=${technicalData.shopName}`,
                requestOptions,
              )
                .then((response) => response.json())
                .then((resultGift) => {
                  const attributes = [
                    { key: '_gift_id', value: resultGift.gift.gift_id },
                    { key: 'Name', value: resultGift.gift.name },
                    { key: 'Message', value: resultGift.gift.message },
                    { key: 'Email', value: resultGift.gift.email },
                  ];
                  const cartAddPayload = {
                    detail: {
                      payload: {
                        id: currentVariant?.id,
                        quantity: parseInt(1, 10),
                        attributes,
                      },
                    },
                  };

                  const addToCartEvent = new CustomEvent(
                    'cart:add',
                    cartAddPayload,
                  );
                  document.dispatchEvent(addToCartEvent);
                  document.dispatchEvent(closeRise);
                  setGiftLoading(false);
                  setName('');
                  setEmail('');
                  setMessage('');
                })
                // eslint-disable-next-line no-console
                .catch((error) => console.log('error', error));
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.log('error', error));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      } else {
        setGiftLoading(false);
      }
      return '';
    };

    document.addEventListener('rise:submit', handleRiseGift);
    return () => {
      document.removeEventListener('rise:submit', handleRiseGift);
    };
  }, [giftLoading, selectedImage, errors]);

  const addToCartButton = useMemo(
    () => (
      <AddToCartButton
        currentVariant={currentVariant}
        currentProduct={currentProduct}
        showQty={false}
        promoMessage={false}
        isMargin={false}
        showPrice={false}
        isGiftCard={true}
        formRef={formRef}
        customClass="!pb-0 !border-b-0"
      />
    ),
    [currentVariant, currentProduct, activeTab],
  );

  const [formMessage, setFormMessage] = useState(
    window.TMW.Strings.risegift.emailSendText,
  );
  const [activeTab, setActiveTab] = useState('email');
  const [sendTime, setSendTime] = useState(false);
  const [timeChoosed, setTimeChoosed] = useState(false);
  const [sendDate, setSendDate] = useState(new Date());

  const tabs = useMemo(
    () => (
      <div className="flex justify-around items-end mb-4">
        <a
          href="#"
          onClick={() => {
            setActiveTab('email');
            setTimeChoosed(false);
            setErrors({ name: false, email: false });
            setFormMessage(window.TMW.Strings.risegift.emailSendText);
          }}
          className={clsx(
            activeTab === 'email' && '!border-black-30',
            'border-b border-transparent font-13 text-center',
          )}
        >
          {window.TMW.Strings.risegift.emailTabHeading}
        </a>
        <a
          href="#"
          onClick={() => {
            setActiveTab('im');
            setTimeChoosed(false);
            setErrors({ name: false, email: false });
            setFormMessage(window.TMW.Strings.risegift.imSendText);
          }}
          className={clsx(
            activeTab === 'im' && '!border-black-30',
            'border-b border-transparent font-13 text-center',
          )}
        >
          {window.TMW.Strings.risegift.imTabHeading}
        </a>
        <a
          href="#"
          onClick={() => {
            setActiveTab('print');
            setTimeChoosed(false);
            setErrors({ name: false, email: false });
            setFormMessage(window.TMW.Strings.risegift.printSendText);
          }}
          className={clsx(
            activeTab === 'print' && '!border-black-30',
            'border-b border-transparent font-13 text-center',
          )}
        >
          {window.TMW.Strings.risegift.printTabHeading}
        </a>
      </div>
    ),
    [activeTab],
  );

  const giftMessage = useMemo(
    () => (
      <div className={`relative max-w-[80%] w-full mx-auto px-3 rounded-md`}>
        <div className="flex justify-start items-start">
          <svg
            fill="#dddddd"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path d="M7 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path>
            <path d="M16 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path>
          </svg>
        </div>
        <p className="text-black text-center max-w-[80%] mx-auto ">
          {message || window.TMW.Strings.risegift.defaultGiftMessage}
        </p>
        <div className="flex justify-end items-start">
          <svg
            fill="#dddddd"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            style="transform: scaleX(-1);"
          >
            <path d="M7 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path>
            <path d="M16 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path>
          </svg>
        </div>
      </div>
    ),
    [message],
  );

  const giftImage = useMemo(
    () => (
      <>
        {giftImages ? (
          <div className="flex flex-col gap-4 max-w-full tablet:max-w-panelinner w-full pb-5 pt-5 tablet:pt-16 justify-start">
            <Swiper
              loop={false}
              slidesPerView={'auto'}
              className={clsx('mx-auto w-full h-[100px] max-w-fit')}
              spaceBetween={4}
            >
              {giftImages &&
                giftImages?.map((image, i) => (
                  <SwiperSlide key={i} className="max-w-[80px]">
                    <div
                      className={clsx(
                        'relative w-20 h-[100px] mx-auto cursor-pointer border-transparent border-2',
                        selectedImage === image && 'border-black',
                      )}
                      onClick={() => setSelectedImage(image)}
                    >
                      <Image
                        src={image}
                        classes={
                          'absolute top-0 left-0 object-cover w-full h-full'
                        }
                        width={'80'}
                        height={'100'}
                      />
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
            <div className="flex flex-col gap-4">
              <Image
                src={selectedImage}
                classes={'mx-auto max-w-[70%] w-full'}
              />
              {giftMessage}
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-4 max-w-full tablet:max-w-panelinner w-full pb-5 pt-5 tablet:pt-16 justify-start">
            <div
              className={clsx(
                'mx-auto w-full h-[100px] max-w-fit flex items-center justify-center gap-8',
              )}
            >
              <div className="max-w-[80px] w-full">
                <div className="relative w-20 h-[100px] mx-auto cursor-pointer animate-pulse-custom bg-pale-taupe" />
              </div>
              <div className="max-w-[80px] w-full">
                <div className="relative w-20 h-[100px] mx-auto cursor-pointer animate-pulse-custom bg-pale-taupe" />
              </div>
              <div className="max-w-[80px] w-full">
                <div className="relative w-20 h-[100px] mx-auto cursor-pointer animate-pulse-custom bg-pale-taupe" />
              </div>
            </div>
            <div className="flex flex-col gap-4 mx-auto max-w-[80%] w-full animate-pulse-custom bg-pale-taupe h-[300px]" />
          </div>
        )}
      </>
    ),
    [selectedImage, giftImages, message],
  );

  const content = useMemo(
    () => (
      <form
        noValidate
        id={`send-gift-${activeTab}`}
        className="mb-5"
        ref={formRef}
      >
        <p className="font-13 text-black mb-4">{formMessage}</p>
        <input
          type="hidden"
          name="send-time"
          value={
            sendDate
              ? `${format(sendDate, "yyyy-MM-dd'T'HH:mm:ss.SSS")}Z`
              : sendDate
          }
        />
        <input type="hidden" name="sending-method" value={activeTab} />
        <input
          type="hidden"
          name="variant-id"
          value={currentVariant.id.replace('gid://shopify/ProductVariant/', '')}
        />
        {activeTab === 'email' && (
          <>
            {!timeChoosed && (
              <>
                <div className="flex justify-start items-start mb-4 flex-col laptop:flex-row">
                  <p className="w-full laptop:w-[30%] mb-2 laptop:mb-0">
                    {window.TMW.Strings.risegift.to}
                  </p>
                  <div className="w-full laptop:w-[70%]">
                    <input
                      type="text"
                      placeholder={window.TMW.Strings.risegift.namePlaceholder}
                      name="name"
                      required="required"
                      className={clsx(
                        'input w-full mb-2',
                        errors.name && 'border-red !mb-0',
                      )}
                      onFocus={() => setErrors({ name: false, email: false })}
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                    {errors.name && (
                      <p className="font-13 text-red mb-2">
                        {window.TMW.Strings.risegift.errorText}
                      </p>
                    )}
                    <input
                      type="email"
                      placeholder={window.TMW.Strings.risegift.emailPlaceholder}
                      name="email"
                      required="required"
                      className={clsx(
                        'input w-full mb-2',
                        errors.email && 'border-red !mb-0',
                      )}
                      onFocus={() => setErrors({ name: false, email: false })}
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                    {errors.email && (
                      <p className="font-13 text-red mb-2">
                        {window.TMW.Strings.risegift.errorEmail}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex justify-start items-start mb-4 flex-col laptop:flex-row">
                  <p className="w-full laptop:w-[30%] mb-2 laptop:mb-0">
                    {window.TMW.Strings.risegift.greeting}
                  </p>
                  <div className="w-full laptop:w-[70%]">
                    <textarea
                      // eslint-disable-next-line max-len
                      placeholder={
                        window.TMW.Strings.risegift.defaultGiftMessage
                      }
                      name="greeting"
                      className="input w-full h-[80px] resize-none"
                      onChange={(e) => setMessage(e.target.value)}
                      value={message}
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center gap-2 w-full">
                  <a
                    className={clsx(
                      !sendTime && 'bg-black text-white',
                      'text-center max-w-[calc(50%-4px)] py-3 inline-block w-full cursor-pointer',
                    )}
                    onClick={() => {
                      setTimeChoosed(false);
                      setSendTime(false);
                      setSendDate(new Date());
                    }}
                  >
                    {window.TMW.Strings.risegift.now}
                  </a>
                  <a
                    className={clsx(
                      sendTime && 'bg-black text-white',
                      'text-center max-w-[calc(50%-4px)] py-3 inline-block w-full cursor-pointer',
                    )}
                    onClick={() => setTimeChoosed(true)}
                  >
                    {sendTime
                      ? format(sendDate, 'MMMM do, yyyy')
                      : window.TMW.Strings.risegift.chooseDate}
                  </a>
                </div>
              </>
            )}
            {timeChoosed && (
              <>
                <a
                  href="#"
                  onClick={() => setTimeChoosed(false)}
                  className="py-2 inline-block mb-2.5"
                >
                  <ArrowLeft />
                </a>
                <Calendar
                  onChange={(value) => {
                    setSendDate(value);
                    setTimeChoosed(false);
                    setSendTime(true);
                  }}
                  value={sendDate}
                  minDate={new Date()}
                />
              </>
            )}
          </>
        )}
        {activeTab !== 'email' && (
          <>
            <div className="flex justify-start items-start mb-4 flex-col laptop:flex-row">
              <p className="w-full laptop:w-[30%] mb-2 laptop:mb-0">
                {window.TMW.Strings.risegift.to}
              </p>
              <div className="w-full laptop:w-[70%]">
                <input
                  type="text"
                  placeholder={window.TMW.Strings.risegift.namePlaceholder}
                  name="name"
                  required="required"
                  className={clsx(
                    'input w-full mb-2',
                    errors.name && 'border-red !mb-0',
                  )}
                  onFocus={() => setErrors({ name: false, email: false })}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
                {errors.name && (
                  <p className="font-13 text-red mb-2">
                    {window.TMW.Strings.risegift.errorText}
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-start items-start flex-col laptop:flex-row">
              <p className="w-full laptop:w-[30%] mb-2 laptop:mb-0">
                {window.TMW.Strings.risegift.greeting}
              </p>
              <div className="w-full laptop:w-[70%]">
                <textarea
                  placeholder={window.TMW.Strings.risegift.defaultGiftMessage}
                  name="greeting"
                  className="input w-full h-[80px] resize-none"
                  onChange={(e) => setMessage(e.target.value)}
                  value={message}
                />
              </div>
            </div>
          </>
        )}
      </form>
    ),
    [
      activeTab,
      formMessage,
      sendTime,
      timeChoosed,
      sendDate,
      errors,
      currentVariant,
    ],
  );

  return (
    <div
      className={clsx(
        'flex gap-0 tablet:gap-8 flex-col tablet:flex-row',
        isMobile && 'pb-10',
      )}
    >
      <div className="flex gap-8 max-w-full tablet:max-w-panelinner">
        <div
          className={
            'flex h-auto flex-col justify-start pb-5 pt-16 tablet:pt-5'
          }
        >
          <p className={'subheading-h3 text-black mb-[10px]'}>
            {window.TMW.Strings.risegift.heading}
          </p>
          {tabs}
          {content}
          {!isMobile && addToCartButton}
        </div>
      </div>
      {giftImage}
      {isMobile && addToCartButton}
    </div>
  );
};

export default Rise;
